'use strict';

const app = angular.module('app', ['ngRoute', 'ngTouch', 'duScroll', 'ngSanitize', 'angularFileUpload', 'ngResource', 'ngCookies']);

app.component('goodSchoolManifesto', {
  templateUrl: './components/good-school-manifesto.html',
  bindings: {
    translation: '<'
  }
});

app.component('teamMember', {
  templateUrl: './components/team-member.html',
  bindings: {
    lang: '<',
    member: '='
  }
});
app.component('feedback', {
  templateUrl: './components/feedback.html',
  bindings: {
    t: '<',
    feedback: '<',
    card: '<'
  }
});
app.component('askForm', {
  templateUrl: './components/ask-form.html',
  controller: 'askForm',
  bindings: {
    t: '<',
  }
});

app.config(['$routeProvider', '$locationProvider',
  function ($routeProvider, $locationProvider) {
    $routeProvider.when('/', {
      templateUrl: 'pages/index.html',
      controller: 'home'
    }).when('/en', {
      templateUrl: 'pages/index.html',
      controller: 'home',
      directlang: 'en'
    }).when('/ru', {
      templateUrl: 'pages/index.html',
      controller: 'home',
      directlang: 'ru'
    }).when('/ua', {
      templateUrl: 'pages/index.html',
      controller: 'home',
      directlang: 'ua'
    }).when('/:lang?/home', {
      templateUrl: 'pages/index.html',
      controller: 'home'
    }).when('/:lang?/courses', {
      templateUrl: 'pages/courses/index.html',
      controller: 'courses'
    }).when('/:lang?/courses/adults', {
      templateUrl: 'pages/courses/adults.html',
      controller: 'adultsLanding'
    }).when('/:lang?/about', {
      templateUrl: 'pages/about.html',
      controller: 'about'
    }).when('/:lang?/anketa', {
      templateUrl: 'pages/forms/first-form.html',
      controller: 'first'
    }).when('/:lang?/anketa/adults', {
      templateUrl: 'pages/forms/main-form.html',
      controller: 'main'
    }).when('/:lang?/anketa/teens', {
      templateUrl: 'pages/forms/main-school-form.html',
      controller: 'main'
    }).when('/:lang?/anketa/last', {
      templateUrl: 'pages/forms/last-form.html',
      controller: 'last'
    }).when('/:lang?/supportus', {
      templateUrl: 'pages/support.html',
      controller: 'supportus'
    }).when('/:lang?/feedback-form', {
      templateUrl: 'pages/forms/feedback-form.html',
      controller: 'feedbackForm'
    }).when('/:lang?/feedback-all', {
      templateUrl: 'pages/feedback-all.html',
      controller: 'feedbackAll'
    }).when('/:lang?/contacts', {
      templateUrl: 'pages/contacts.html',
    }).when('/:lang?/email-confirmed', {
      templateUrl: 'pages/email-confirmed.html',
    }).otherwise({
      redirectTo: '/'
    });
    $locationProvider.html5Mode(true).hashPrefix('!');
  }
]);

window.isImage = function (file) {
  const type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
  return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
}

function sendPageViewToGTM(newPath, previousPath) {
  if (previousPath && previousPath.loadedTemplateUrl === newPath.loadedTemplateUrl) {
    return;
  }

  // gtag('set', 'page_path', window.location.pathname);
  // gtag('event', 'page_view');
}

app.run(function ($rootScope, $location, $anchorScroll, $routeParams, $timeout) {
  $rootScope.$on('$routeChangeSuccess', function (event, newPath, previousPath) {
    // todo: !!!
    $timeout(function () {
      // $anchorScroll();
    }, 700);
  })
});

app.service('translationService', function ($resource) {
  this.getTranslation = function ($scope, language, $http) {
    const languageFilePath = $scope.config.urls.translationsUrl + language + '.json';
    $http.get(languageFilePath).success(function (data) {
      function applyToObject(obj, lambda) {
        return Object.keys(obj).reduce((acc, key) => {
          return Object.assign(acc, {
            [key]: (obj[key] && typeof obj[key] === 'object') ? applyToObject(obj[key], lambda) : lambda(obj[key])
          });
        }, {})
      }

      setTimeout(() => {
        new MessengersWidget({
          color: "#27ae60",
          title: data.contact.title,
          messengers: {
            phone: "+380502011180",
            email: "info@programming.org.ua",
            telegram: "shpp_me",
            viber: "380502011180",
            facebook: "626295794236927",
          },
          titles: {
            phone: data.contact.call,
            email: data.contact.email,
            telegram: data.contact.telegram,
            viber: data.contact.viber,
            facebook: data.contact.facebook
          },
        });
      }, 0);
      $scope.translation = applyToObject(data, $scope.trustAsHtml);
      $scope.translationCallback();
    });
  }
});

app.service('$location_skip', ['$location', '$route', '$rootScope', function ($location, $route, $rootScope) {
  $location.skipReload = function () {
    const lastRoute = $route.current;
    const un = $rootScope.$on('$locationChangeSuccess', function () {
      $route.current = lastRoute;
      un();
    });
    return $location;
  };
  return $location;
}]);

app.service('getConfigurations', function ($http) {
  return function ($scope, callback) {
    $http.get('/config.json').success(function (data) {
      $scope.config = {};
      $scope.config.camera = data.camera;

      const baseUrl = data.backendUrl;
      const newsUrl = data.newsUrl;
      $scope.config.urls = {
        getFeedback: `${baseUrl}${data.endpoints.getFeedback}`,
        translationsUrl: data.translationsUrl,
        createFeedback: `${baseUrl}${data.endpoints.createFeedback}`,
        getNewsPreview: `${newsUrl}`,
        incrementNewsViews: `${baseUrl}${data.endpoints.incrementNewsViews}`,
        saveQuestion: `${baseUrl}${data.endpoints.saveQuestion}`,
        createStudent: `${baseUrl}${data.endpoints.createStudent}`,
        uploadStudentPhoto: `${baseUrl}${data.endpoints.uploadStudentPhoto}`,
        feedbacksImages: `${baseUrl}${data.endpoints.feedbacksImages}`,
        newsImages: `${baseUrl}${data.endpoints.newsImages}`,
        studentsImages: `${baseUrl}${data.endpoints.studentsImages}`,
        nearestStartDateUrl: data.nearestStartDateUrl
      };

      if (typeof callback === 'function') {
        callback();
      }
    });
  }
});

app.directive('scroll', function ($window) {
  return function (scope) {
    angular.element($window).bind('scroll', function () {
      if (this.pageYOffset >= 500)
        angular.element('#scrollup').fadeIn('slow');
      else
        angular.element('#scrollup').fadeOut('slow');
      scope.$apply();
    });
  }
});

app.directive('ngThumb', ['$window', function ($window) {
  const helper = {
    support: !!($window.FileReader && $window.CanvasRenderingContext2D),
    isFile: function (item) {
      return angular.isObject(item) && item instanceof $window.File;
    },
    isImage: isImage
  };

  return {
    restrict: 'A',
    template: `
<div class="relative">
  <button type="button" class="close" data-ng-click="uploader.queue[0].remove()">
    <i class="fa fa-times"></i>
  </button>
  <canvas/>
</div>`,
    link: function (scope, element, attributes) {
      if (!helper.support) return;

      const params = scope.$eval(attributes.ngThumb);

      if (!helper.isFile(params.file)) return;
      if (!helper.isImage(params.file)) return;

      const canvas = element.find('canvas');
      const reader = new FileReader();

      reader.onload = onLoadFile;
      reader.readAsDataURL(params.file);

      function onLoadFile(event) {
        const img = new Image();
        img.onload = onLoadImage;
        img.src = event.target.result;
      }

      function onLoadImage(e) {
        const width = params.width || this.width / this.height * params.height;
        const height = params.height || this.height / this.width * params.width;
        canvas.attr({width: width, height: height});
        canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
      }
    }
  };
}]);
